import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { setupAxiosInterceptors } from "../utils/axios-interceptor";

/**
 * Componente que configura os interceptors do axios
 * Deve ser renderizado dentro do Router e AuthProvider
 */
export function AxiosInterceptorSetup() {
  const navigate = useNavigate();
  const { logout } = useAuth();

  useEffect(() => {
    setupAxiosInterceptors(navigate, logout);
  }, [navigate, logout]);

  return null;
}

